import React from "react"
import { PaperclipIcon } from "components/page-components/Icons/small"

export const MessageModal = ({
  set_message_modal_state,
  message_modal_state,
  set_message_cta_modal_open,
}) => {
  const close_message_modal = () => {
    set_message_modal_state({
      body: "",
      subject: "",
      attachments: "",
      message_modal_open: "",
    })
  }

  const cta_button_click = () => {
    close_message_modal()
    set_message_cta_modal_open("is-active")
  }

  const { body, subject, attachments, message_modal_open } = message_modal_state

  return (
    <div className={`modal ${message_modal_open}`}>
      <div
        className="modal-background"
        onClick={close_message_modal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close Message Modal"
      ></div>
      <div className="modal-content">
        <div className="box py-5">
          <p className="title is-5 has-text-mitternachtsblau">{subject}</p>
          <p className="has-text-mitternachtsblau has-text-weight-bold mb-4">
            Nachricht:
          </p>
          <div
            className="has-background-mitternachtsblau-5 px-3 py-5 has-text-mitternachtsblau mb-5 content"
            dangerouslySetInnerHTML={{ __html: body }}
            style={{ minHeight: 275 }}
          ></div>
          {!!attachments?.[0] ? (
            <div className="">
              <p className="has-text-mitternachtsblau has-text-weight-bold mb-4">
                Anhänge:
              </p>
              <ul>
                {attachments?.map(({ name, link, filesize }) => {
                  return (
                    <li className="is-flex">
                      <span className="mr-3">
                        <PaperclipIcon />
                      </span>
                      <a href={link} className="link mr-3">
                        {name}
                      </a>
                      <span className="has-text-mitternachtsblau-30">
                        {filesize}
                      </span>
                    </li>
                  )
                })}
              </ul>
            </div>
          ) : null}
          <div className="buttons is-right">
            <button
              className="has-text-weight-bold button is-tertiary"
              onClick={close_message_modal}
            >
              Schließen
            </button>
            <button
              onClick={cta_button_click}
              className="has-text-weight-bold button is-mitternachtsblau is-outlined"
            >
              Weiterleiten
            </button>
            <button
              onClick={cta_button_click}
              className="has-text-weight-bold button is-sonnengelb"
            >
              Antworten
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
